export const ROOT = '';
export const MAIN_PAGE_ROUTE = `${ROOT}/`;
export const RESULTS_PAGE_ROUTE = `${MAIN_PAGE_ROUTE}results`;
export const IFRAME_EXAMPLES_PAGE_ROUTE = `${MAIN_PAGE_ROUTE}iframe-examples`;
